import { Box, IconButton, Tooltip } from '@wix/design-system';
import React, { useEffect, useRef, useState } from 'react';
import { dataHooks } from '../../utils/datahooks';
export const ruleElementWidth = {
  full: '100%',
  large: '372px',
  normal: '264px',
  small: '252px'
};
export const HoverStyledBox = _ref => {
  let {
    notHoveredBorderColor,
    iconButton,
    iconButtonTooltip,
    onClickIcon,
    iconButtonZIndex = 1,
    isShowIconButton = false,
    isOpen = false,
    onClick,
    children,
    dataHook,
    width,
    disabled = false,
    autoFocus = false
  } = _ref;
  const [isHovered, setIsHovered] = useState(false);
  const [initialFocus, setInitialFocus] = useState(autoFocus);
  const wrapperRef = useRef(null);
  useEffect(() => {
    if (!initialFocus) {
      return;
    }
    const handleClickOutside = event => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setInitialFocus(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [initialFocus]);
  const showIcon = Boolean(iconButton) && isHovered && isShowIconButton;
  return /*#__PURE__*/React.createElement("div", {
    "data-hook": dataHooks.a11yWizardHoverBoxContainerDiv(dataHook),
    style: {
      cursor: isOpen || disabled ? 'default' : 'pointer',
      position: 'relative'
    },
    onClick: !isOpen ? onClick : undefined,
    onMouseEnter: () => !disabled && setIsHovered(true),
    onMouseLeave: () => !disabled && setIsHovered(false)
  }, /*#__PURE__*/React.createElement(Box, {
    backgroundColor: !isOpen && isHovered ? 'B60' : 'transparent',
    borderColor: initialFocus ? '#116DFF' : isHovered ? '#7CAFFF' : notHoveredBorderColor,
    borderRadius: "6px",
    dataHook: dataHooks.a11yWizardHoverBoxContainer(dataHook),
    position: "relative",
    ref: wrapperRef,
    width: ruleElementWidth[width]
  }, showIcon && /*#__PURE__*/React.createElement(Box, {
    position: "absolute",
    right: "18px",
    top: "11px",
    zIndex: iconButtonZIndex
  }, /*#__PURE__*/React.createElement(Tooltip, {
    content: iconButtonTooltip,
    dataHook: dataHooks.a11yWizardHoverBoxIconButtonTooltip(dataHook),
    disabled: !iconButtonTooltip
  }, /*#__PURE__*/React.createElement(IconButton, {
    dataHook: dataHooks.a11yWizardHoverBoxIconButton(dataHook),
    priority: "secondary",
    size: "tiny",
    onClick: e => {
      e.stopPropagation();
      !disabled && (onClickIcon == null ? void 0 : onClickIcon());
    }
  }, iconButton))), children));
};
//# sourceMappingURL=hover-styled-box.js.map